import React, { useEffect } from 'react';
import { IConsentInfoProps } from '../../types/IConsentInfoProps';
import ReconfirmationStageAccountPageContent from './ReconfirmationStageAccountPageContent';
import { useTranslation } from 'react-i18next';
import { accessTokenStorage } from '../../domain/services';
import { useHistory } from 'react-router';
import { useReconfirmConsentConnection } from '../../hooks/mutationHooks';
import Loader from '../loader/Loader';
import ErrorScreenTypeEnum from '../../types/enums/errorScreenTypeEnum';
import Container from '../container/Container';
import { LogoHeader } from '../consent/LogoHeader';
import { useErrorState, useSelectedBank, useStepsState } from '../../hooks/zustandHooks';

interface IProps {
  consentInfo: IConsentInfoProps;
  replacementTokens: { [key: string]: any };
}

const ReconfirmationStagePage: React.FC<IProps> = (props: IProps) => {
  const { consentInfo, replacementTokens } = props;

  const { t } = useTranslation();
  const history = useHistory();
  const { selectedBank } = useSelectedBank();
  const bankLogoUrl = selectedBank?.logoUrl;
  const setError = useErrorState(state => state.setError);
  const { mutateAsync, isPending } = useReconfirmConsentConnection();

  const setActiveStep = useStepsState(state => state.setActiveStep);

  useEffect(() => {
    setActiveStep({ stepIndex: 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (window.hj) {
      window.hj('tagRecording', ['Screen: Reconfirm Screen']);
    }
  }, []);

  function handleDisconnect() {
    if (!accessTokenStorage.hasToken() || !consentInfo) {
      setError({
        type: ErrorScreenTypeEnum.ReconfirmationError,
        code: `no ${!consentInfo ? 'consent information' : 'access token'} could be found.`
      });
      history.push('/error');
      return;
    }

    history.push('/account-disconnection');
  }

  if (isPending) {
    return <Loader display={isPending} spinnerText={t('Loading...')} />;
  }

  return (
    <Container
      primaryBtn={{
        text: t('Reconfirm'),
        onClick: async () => await mutateAsync()
      }}
      secondaryBtn={{
        text: t('Disconnect'),
        onClick: handleDisconnect
      }}
    >
      <LogoHeader bankLogoUrl={bankLogoUrl} bankName={consentInfo.providerName} />
      <ReconfirmationStageAccountPageContent
        accounts={consentInfo.accounts}
        bankName={consentInfo.providerName}
        replacementTokens={replacementTokens}
        t={t}
      />
    </Container>
  );
};

export default ReconfirmationStagePage;
